import {
  Box,
  Button,
  Checkbox,
  FormLabel,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import Title from "../../ui/Title";
import { StyledInput } from "../../ui/StyledInput";
import { OrderFormType } from "../orders/AddOrder";
import { ChangeEvent, Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { storeOrder } from "./orderApi";
import Seperator from "../../ui/Seperator";
import { StyledButton } from "../../ui/StyledButton";

const PackageDetailsForm = ({
  label,
  handleBack,
  finalForm,
  setFinalForm,
  isEdit,
}: {
  label: string;
  handleBack: () => void;
  setFinalForm: (finalForm: any) => void;
  finalForm: OrderFormType;
  isEdit: boolean;
}) => {
  const [itemsIdentical, setItemsIdentical] = useState<boolean[]>([false]);

  const [canNext, setCanNext] = useState(true);

  const navigate = useNavigate();

  const onlyNumber = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    limit: number
  ) => {
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, "");

    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts[1];
    }
    return value.slice(0, limit);
  };

  const handleNumberInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string,
    index: number
  ) => {
    e.target.value = onlyNumber(e, 10);

    const newFormData = { ...finalForm };

    newFormData.package_details[index][field] = e.target.value;
    setFinalForm(newFormData);
  };

  // const handleInputChange = (
  //   e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   field: string,
  //   index: number
  // ) => {
  //   const newFormData = { ...finalForm };
  //   newFormData.package_details[index][field] = e.target.value;
  //   setFinalForm(newFormData);
  // };

  const handlePackageInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string,
    index: number
  ) => {
    const newFormData = { ...finalForm };
    newFormData.package_details[index][field] = e.target.value;
    setFinalForm(newFormData);
  };

  const handleAddPackage = () => {
    const newFormData = { ...finalForm };
    newFormData.package_details.push({
      length: "",
      width: "",
      height: "",
      weight: "",
      description: "",
      quantity: 0,
      product_name: "",
    });

    setFinalForm(newFormData);
  };
  const handleRemovePackage = () => {
    const newFormData = { ...finalForm };
    newFormData.package_details.pop();
    setFinalForm(newFormData);
  };

  const handleItemsIdentical = (
    _event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    index: number
  ) => {
    const newFormData = { ...finalForm };
    const tempItems = [...itemsIdentical];
    if (checked) {
      const packageData = finalForm.package_details[index - 1];
      tempItems[index] = true;

      newFormData.package_details[index] = {
        length: packageData.length,
        width: packageData.width,
        height: packageData.height,
        weight: packageData.weight,
        description: newFormData.package_details[index].description,
        quantity: newFormData.package_details[index].quantity,
        product_name: newFormData.package_details[index].product_name,
      };
    } else {
      tempItems[index] = false;

      newFormData.package_details[index] = {
        length: "",
        width: "",
        height: "",
        weight: "",
        description: newFormData.package_details[index].description,
        quantity: newFormData.package_details[index].quantity,
        product_name: newFormData.package_details[index].product_name,
      };
    }
    setItemsIdentical(tempItems);
    setFinalForm(newFormData);
  };

  const checkIfAllIdentical = useCallback(() => {
    for (let i = 1; i < itemsIdentical.length; i++) {
      if (itemsIdentical[i] === false) {
        return false;
      }
    }
    return true;
  }, [itemsIdentical]);

  useEffect(() => {
    const newFormData = { ...finalForm };
    newFormData.items_identical = checkIfAllIdentical();
    setFinalForm(newFormData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkIfAllIdentical]);

  const handleSubmit = () => {
    const allPackages = finalForm.package_details;
    allPackages?.forEach((el) => {
      el.height = parseFloat(el.height as string);
      el.length = parseFloat(el.length as string);
      el.quantity = parseFloat(el.quantity as string);
      el.weight = parseFloat(el.weight as string);
      el.width = parseFloat(el.width as string);
    });

    storeOrder({
      ...finalForm,
      receiver_address: {
        ...finalForm?.receiver_address,
        postal_code: `${finalForm?.receiver_address?.postal_code}`,
      },
    })
      .then((data) => {
        toast.success("Order added!");
        navigate("/order");
      })
      .catch((error) => console.log(error));
  };

  const validateForm = useCallback(() => {
    let canNext = true;

    finalForm.package_details.forEach((el, index) => {
      canNext = true;
      if (
        finalForm.package_details[index].description.trim() !== "" &&
        finalForm.package_details[index].height !== "" &&
        finalForm.package_details[index].length !== "" &&
        finalForm.package_details[index].quantity !== 0 &&
        finalForm.package_details[index].weight !== "" &&
        finalForm.package_details[index].product_name.trim() !== "" &&
        finalForm.package_details[index].height !== ""
      ) {
        canNext = false;
      }
    });
    setCanNext(canNext);
  }, [finalForm]);

  useEffect(() => {
    validateForm();
  }, [validateForm]);

  return (
    <>
      <Title title={`${label}`} />
      <Box
        sx={{
          margin: "10px 0",
        }}
      >
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography>Package Details</Typography>
            </Grid>
            {finalForm.package_details.map((el, index) => (
              <Fragment key={index}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormLabel>
                    <Typography fontSize={12}>Description</Typography>
                  </FormLabel>
                  <StyledInput
                    placeholder="Description"
                    fullWidth
                    value={finalForm.package_details[index]?.description}
                    onChange={(e) =>
                      handlePackageInputChange(e, "description", index)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormLabel>
                    <Typography fontSize={12}>Product name</Typography>
                  </FormLabel>
                  <StyledInput
                    placeholder="Product Name"
                    fullWidth
                    value={finalForm.package_details[index]?.product_name}
                    onChange={(e) =>
                      handlePackageInputChange(e, "product_name", index)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <FormLabel>
                    <Typography fontSize={12}>Dead Weight</Typography>
                  </FormLabel>
                  <StyledInput
                    disabled={itemsIdentical[index]}
                    value={finalForm.package_details[index]?.weight}
                    onChange={(e) =>
                      handleNumberInputChange(e, "weight", index)
                    }
                    placeholder="0.00 kg"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <FormLabel>
                    <Typography fontSize={12}>Qunatity</Typography>
                  </FormLabel>
                  <StyledInput
                    value={finalForm.package_details[index]?.quantity}
                    onChange={(e) =>
                      handleNumberInputChange(e, "quantity", index)
                    }
                    placeholder="0.00"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormLabel>
                    <Typography fontSize={12}>Volumetric Weight</Typography>
                    <Typography fontSize={10}>
                      Enter packages dimensions to calculate Volumetric Weight
                    </Typography>
                  </FormLabel>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={2}>
                      <StyledInput
                        disabled={itemsIdentical[index]}
                        value={finalForm.package_details[index]?.height}
                        onChange={(e) =>
                          // handleNumberInputChange(e, "height", index)
                          handleNumberInputChange(e, "height", index)
                        }
                        placeholder="H: 0.00 cm"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <StyledInput
                        disabled={itemsIdentical[index]}
                        value={finalForm.package_details[index]?.width}
                        onChange={(e) =>
                          // handleNumberInputChange(e, "width", index)
                          handleNumberInputChange(e, "width", index)
                        }
                        placeholder="W: 0.00 cm"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <StyledInput
                        disabled={itemsIdentical[index]}
                        value={finalForm.package_details[index]?.length}
                        onChange={(e) =>
                          // handleNumberInputChange(e, "length", index)
                          handleNumberInputChange(e, "length", index)
                        }
                        placeholder="L: 0.00 cm"
                        fullWidth
                      />
                    </Grid>
                    {index > 0 && (
                      <Grid item xs={12}>
                        <Button
                          onClick={handleRemovePackage}
                          variant="text"
                          sx={{
                            fontSize: "12px",
                            textTransform: "none",
                          }}
                        >
                          + Remove Product
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                {index > 0 && (
                  <Grid item xs={12}>
                    <Stack
                      direction={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"center"}
                    >
                      <Checkbox
                        onChange={(e, value) =>
                          handleItemsIdentical(e, value, index)
                        }
                        size="small"
                      />
                      <Typography fontSize={12}>Items identicial</Typography>
                    </Stack>
                  </Grid>
                )}
                <Grid item md={12}>
                  <Seperator />
                </Grid>
              </Fragment>
            ))}
            <Grid item xs={12}>
              <Button
                onClick={handleAddPackage}
                variant="text"
                sx={{
                  fontSize: "12px",
                  textTransform: "none",
                }}
              >
                + Add Product
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Stack
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        marginTop={2}
        columnGap={2}
      >
        <StyledButton variant="contained" onClick={handleBack}>
          Back
        </StyledButton>
        <StyledButton
          disabled={canNext}
          onClick={handleSubmit}
          variant="contained"
        >
          {isEdit ? "Update" : "Add"} Order
        </StyledButton>
      </Stack>
    </>
  );
};

export default PackageDetailsForm;
